import ApiService from '../../../../../../services/ApiService'
import Utils from '../../../../../../Utils/FormatDate'

export default {
  props: {
    filterProp: Object,
  },
  components: {},

  data() {
    return {
      apiService: new ApiService(),
      loading: false,
      showChart: true,
      failures: [],
      expanded: [],
      page: 1,
      totalPages: 1,
      pageSize: 7,
      headerProps: {
        sortByText: 'Ordenar por',
      },
      header: [
        {
          text: '',
          align: 'center',
          value: '',
        },
        {
          text: 'Identificação',
          align: 'center',
          value: 'identification',
        },
        {
          text: 'Equipamento',
          align: 'center',
          value: 'equipmentName',
        },
        {
          text: 'Fabricante',
          align: 'center',
          value: 'manufacturer',
        },
        {
          text: 'Modelo',
          align: 'center',
          value: 'model',
        },
        {
          text: 'Quantidade Falhas',
          align: 'center',
          value: 'failuresQuantity',
        },
        {
          text: 'MTBF',
          align: 'center',
          value: 'mtbf',
        },
      ],
      mobileHeader: [
        {
          text: 'Equipamento',
          align: 'center',
          value: 'equipmentName',
        },
        {
          text: 'MTBF',
          align: 'center',
          value: 'mtbf',
        },
      ],
      total: 0,
    }
  },
  async created() {
    this.listFailures()
  },
  methods: {
    requestExcel() {
      this.filterProp.pageSize = 10000
      let now = new Date()
      var filename = `Equipment_Failures_${now.getDate()}-${
        now.getMonth() + 1
      }-${now.getFullYear()}.xlsx`
      this.apiService
        .post('excel/equipmentFailures', this.filterProp)
        .then((response) => {
          response = `data:application/octet-stream;base64,${response.content}`
          const link = document.createElement('a')
          link.href = response
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
        })
    },
    async listFailures() {
      this.loading = true
      await this.apiService
        .post('reports/failuresEquipment', this.filterProp)
        .then((response) => {
          this.showChart = response.content.objects.length > 0
          this.failures = response.content.objects
          this.total = response.content.pager.totalItems
          this.totalPages = response.content.pager.totalPages
        })
        .catch((err) => {})
      this.loading = false
    },

    formatDate(date) {
      return Utils.dateTime(date)
    },
  },
  watch: {
    page() {
      this.filterProp.page = this.page
      this.listFailures()
    },
  },
}
